import { cn } from '@/lib/utils';

const BARS = 12;

/**
 * Segmented level meter. Bars rather than a continuous fill because the
 * discrete steps stay legible at the small size this renders at, and the last
 * few segments can be tinted to warn about clipping.
 */
export function MicMeter({
  level,
  muted,
  className,
}: {
  level: number;
  muted: boolean;
  className?: string;
}) {
  const lit = muted ? 0 : Math.round(level * BARS);

  return (
    <div className={cn('flex items-center gap-[3px]', className)} aria-hidden="true">
      {Array.from({ length: BARS }, (_, index) => {
        const on = index < lit;
        const hot = index >= BARS - 3;
        return (
          <span
            key={index}
            className={cn(
              'h-3 w-[3px] rounded-full transition-[background-color,opacity,transform] duration-75',
              on
                ? hot
                  ? 'bg-[var(--warning)]'
                  : 'bg-[var(--success)]'
                : 'bg-white/15',
              on && 'scale-y-125',
            )}
          />
        );
      })}
    </div>
  );
}
